export default __webpack_public_path__ + "static/accessoires.cover-c2f2191f0cae0fb3a0f89d4a40d4a5f1.jpg";